import { Form, Modal, Button, Row, Col } from 'react-bootstrap'

function ClaudeAccountForm({ show, onHide, editingAccount, formData, setFormData, onSubmit }) {
  return (
    <Modal show={show} onHide={onHide} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{editingAccount ? 'Modifier' : 'Ajouter'} un Compte Claude</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={onSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Email Claude *</Form.Label>
            <Form.Control
              type="email"
              value={formData.email}
              onChange={(e) => setFormData({ ...formData, email: e.target.value })}
              required
              disabled={!!editingAccount}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Label *</Form.Label>
            <Form.Control
              type="text"
              value={formData.label}
              onChange={(e) => setFormData({ ...formData, label: e.target.value })}
              required
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Plan *</Form.Label>
            <Form.Select
              value={formData.plan}
              onChange={(e) => setFormData({ ...formData, plan: e.target.value })}
              required
            >
              <option value="free">Free (Gratuit)</option>
              <option value="pro">Pro ($20/mois)</option>
              <option value="max">Max (Entreprise)</option>
            </Form.Select>
          </Form.Group>

          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Limite Quotidienne *</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.daily_request_limit}
                  onChange={(e) => setFormData({ ...formData, daily_request_limit: parseInt(e.target.value) })}
                  required
                  min="1"
                />
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>Limite par Minute *</Form.Label>
                <Form.Control
                  type="number"
                  value={formData.minute_request_limit}
                  onChange={(e) => setFormData({ ...formData, minute_request_limit: parseInt(e.target.value) })}
                  required
                  min="1"
                />
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Check
              type="checkbox"
              label="Actif"
              checked={formData.is_active}
              onChange={(e) => setFormData({ ...formData, is_active: e.target.checked })}
            />
          </Form.Group>

          <div className="d-flex justify-content-end gap-2">
            <Button variant="secondary" onClick={onHide}>
              Annuler
            </Button>
            <Button variant="primary" type="submit">
              {editingAccount ? 'Mettre à jour' : 'Créer'}
            </Button>
          </div>
        </Form>
      </Modal.Body>
    </Modal>
  )
}

export default ClaudeAccountForm
